import _styled from "styled-components";
import { useTranslation } from 'next-i18next';
import Lottie from 'lottie-react';
import sandyLoadingAnimationData from './sandy_loading.json';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CvParsingLoadingState = function CvParsingLoadingState() {
  var _useTranslation = useTranslation('onboarding-page'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(LoadingStateContainer, {
    children: [/*#__PURE__*/_jsx(Lottie, {
      loop: true,
      animationData: sandyLoadingAnimationData
    }), /*#__PURE__*/_jsx(LoadingText, {
      children: t('cv_loading.reorganizing_work_experiences')
    })]
  });
};

var LoadingStateContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "cv-parsing-loading-state__LoadingStateContainer",
  componentId: "sc-mu0eim-0"
})(function () {
  return [{
    "display": "flex",
    "width": "100%",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "gap": "1.5rem",
    "paddingTop": "2rem",
    "paddingBottom": "2rem",
    "paddingLeft": "1rem",
    "paddingRight": "1rem",
    "@media (min-width: 768px)": {
      "paddingLeft": "2rem",
      "paddingRight": "2rem"
    }
  }];
});

var LoadingText = /*#__PURE__*/_styled.div.withConfig({
  displayName: "cv-parsing-loading-state__LoadingText",
  componentId: "sc-mu0eim-1"
})(function () {
  return [{
    "maxWidth": "24rem",
    "textAlign": "center",
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "fontWeight": "500",
    "--tw-text-opacity": "1",
    "color": "rgb(17 24 39 / var(--tw-text-opacity))",
    "@media (min-width: 768px)": {
      "maxWidth": "28rem",
      "fontSize": "1.125rem",
      "lineHeight": "1.75rem"
    }
  }];
});